module.exports = __webpack_public_path__ + "static/jason-2-e75f85a298cfebe8c4514c30037f0aed.jpg";